import React, { Component } from 'react'
import {NavLink} from 'react-router'
import './List.css'
import API from '../API'
import AddIcon from '../Icons/Add.svg'
import ListEntry from './ListEntry'

class ProjectList extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
		this.Refresh()
	}
	async Refresh() {
		this.setState({Projects: await API("Projects/List")})
	}
	render() {
		if (this.state.Projects) {
			const Active = []
			const Inactive = []
			for (let x in this.state.Projects||[]) {
				if (this.state.Filter?.length && this.state.Projects[x].Name.toLocaleLowerCase().indexOf(this.state.Filter.toLocaleLowerCase()) == -1)
					continue
				if (this.state.Projects[x]?.Active)
					Active.push(<ListEntry list={this} project={this.state.Projects[x]} />)
				else
					Inactive.push(<ListEntry list={this} project={this.state.Projects[x]} />)
			}
			return (
				<div className="ProjectList">
					<div class="Row">
						<NavLink to="/ui/project/_"><img style={{height:'2.2em'}}className="Icon" src={AddIcon} /></NavLink>
						<input value={this.state.Filter} className={this.state.Filter?'Changed':''} onInput={e=>this.setState({Filter:e.target.value})} />
					</div>
					<h1>Active Projects</h1>
						{Active}
					<h1>Inactive Projects</h1>
						{Inactive}
				</div>
			)
		} else {
			return (<div className="ProjectList Loading">Loading...</div>)
		}
	}
}

export default ProjectList

